/* VENDORS */
export const GET_VENDORS = "GET_VENDORS"
export const GET_VENDORS_SUCCESS = "GET_VENDORS_SUCCESS"
export const GET_VENDORS_FAIL = "GET_VENDORS_FAIL"

/* VENDORS PROFILE */
export const GET_VENDOR_PROFILE = "GET_VENDOR_PROFILE"
export const GET_VENDOR_PROFILE_SUCCESS = "GET_VENDOR_PROFILE_SUCCESS"
export const GET_VENDOR_PROFILE_FAIL = "GET_VENDOR_PROFILE_FAIL"

/**
 * add VENDOR
 */
 export const ADD_NEW_VENDOR = "ADD_NEW_VENDOR"
 export const ADD_VENDOR_SUCCESS = "ADD_VENDOR_SUCCESS"
 export const ADD_VENDOR_FAIL = "ADD_VENDOR_FAIL"

 /**
 * Edit VENDOR
 */
export const UPDATE_VENDOR = "UPDATE_VENDOR"
export const UPDATE_VENDOR_SUCCESS = "UPDATE_VENDOR_SUCCESS"
export const UPDATE_VENDOR_FAIL = "UPDATE_VENDOR_FAIL"

/**
 * Delete VENDOR
 */
export const DELETE_VENDOR = "DELETE_VENDOR"
export const DELETE_VENDOR_SUCCESS = "DELETE_VENDOR_SUCCESS"
export const DELETE_VENDOR_FAIL = "DELETE_VENDOR_FAIL"

export const SET_PAGE = "SET_PAGE"
export const SET_OFFSET = "SET_OFFSET"
export const SET_QUERY = "SET_QUERY"



